module.exports = __webpack_public_path__ + "img/arrow-right.6a3130e9.png";